import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Dimension, getActiveDocument } from 'vscode/vscode/vs/base/browser/dom';
import { codiconsLibrary } from 'vscode/vscode/vs/base/common/codiconsLibrary';
import { Lazy } from 'vscode/vscode/vs/base/common/lazy';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IHoverService } from 'vscode/vscode/vs/platform/hover/browser/hover.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { defaultInputBoxStyles } from 'vscode/vscode/vs/platform/theme/browser/defaultStyles';
import { getIconRegistry } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';
import { WorkbenchIconSelectBox } from 'vscode/vscode/vs/workbench/services/userDataProfile/browser/iconSelectBox';

const icons = ( new Lazy(() => {
    const iconDefinitions = getIconRegistry().getIcons();
    const includedChars = ( new Set());
    const dedupedIcons = iconDefinitions.filter(e => {
        if (e.id === codiconsLibrary.blank.id) {
            return false;
        }
        if (!('fontCharacter' in e.defaults)) {
            return false;
        }
        if (( includedChars.has(e.defaults.fontCharacter))) {
            return false;
        }
        includedChars.add(e.defaults.fontCharacter);
        return true;
    });
    return dedupedIcons;
}));
let TerminalIconPicker = class TerminalIconPicker extends Disposable {
    constructor(instantiationService, _hoverService) {
        super();
        this._hoverService = _hoverService;
        this._iconSelectBox = instantiationService.createInstance(WorkbenchIconSelectBox, {
            icons: icons.value,
            inputBoxStyles: defaultInputBoxStyles,
            showIconInfo: true
        });
    }
    async pickIcons() {
        const dimension = ( new Dimension(486, 260));
        return ( new Promise(resolve => {
            this._register(this._iconSelectBox.onDidSelect(e => {
                resolve(e);
                this._iconSelectBox.dispose();
            }));
            this._iconSelectBox.clearInput();
            const hoverWidget = this._hoverService.showHover({
                content: this._iconSelectBox.domNode,
                target: getActiveDocument().body,
                position: {
                    hoverPosition: 2 ,
                },
                persistence: {
                    sticky: true,
                },
                appearance: {
                    showPointer: true
                }
            }, true);
            if (hoverWidget) {
                this._register(hoverWidget);
            }
            this._iconSelectBox.layout(dimension);
            this._iconSelectBox.focus();
        }));
    }
};
TerminalIconPicker = ( __decorate([
    ( __param(0, IInstantiationService)),
    ( __param(1, IHoverService))
], TerminalIconPicker));

export { TerminalIconPicker };
